import lajkonikLogo from '@rewardopl/assets/logos/lajkonik.svg';

import { Image, Wrapper } from './vendor_logo.styles';

import { VENDOR_BUSINESS_NAME } from '../../constants';

type VendorLogoProps = { width?: number };

export default function VendorLogo({ width = 150 }: VendorLogoProps) {
  const height = width;

  return (
    <Wrapper>
      <Image alt={VENDOR_BUSINESS_NAME} height={height} src={lajkonikLogo} width={width} />
    </Wrapper>
  );
}
